import "./ChannelSearchViewer.css";

import React, { Component } from "react";

import ChannelList from "../components/ChannelList";
import ChannelMap from "../components/ChannelMap";

class ChannelSearchViewer extends Component {
  constructor(props) {
    super(props);

    this.state = { hoveredChannel: null };
    this.onHoverHandle = this.onHoverHandle.bind(this);
  }

  onHoverHandle(channel) {
    this.setState({ hoveredChannel: channel });
  }

  render() {
    const { hoveredChannel } = this.state;
    const { channels, lat, lng } = this.props;

    return (
      <div className="channel-search-viewer">
        <ChannelMap
          emphasize={[hoveredChannel]}
          channels={channels}
          center={[lat, lng]}
          zoom={7}
        />
        <ChannelList channels={channels} onHover={this.onHoverHandle} />
      </div>
    );
  }
}

export default ChannelSearchViewer;
